/*
 * サブシステム名：ツール
 * 機能名：会計連携データ作成
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdDateBox from '@/components/DdDateBox'
import DdTextBox from '@/components/DdTextBox'
import DdDropDown from '@/components/DdDropDown'
import DdCheckbox from '@/components/DdCheckbox'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import validators from '@/rahmen/validators'
// import date from '@/ddv2.library/date'
// import modals from '@/ddv2.library/modals'

export default {
  name: 'kaikeiRenkeiDataCreate',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {},
    rec: [],
    headersJininList: header.mstJininHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdCustomButton,
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdTextBox,
    DdCodeTextBox,
    DdDateBox,
    DdDropDown,
    DdCheckbox
  },
  watch: {
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        // 表示フォーマット編集
        const elem2 = { ...elem }
        elem2.juchuYmdDisp = elem.juchuYmd ? filter.dateFormatter(elem.juchuYmd) : ''
        elem2.iraiDaisuDisp = elem.iraiDaisu === null || elem.iraiDaisu === undefined ? '' : filter.numericFormatter(elem.iraiDaisu)
        elem2.sagyoNaiyoKakuteiYmdDisp = elem.sagyoNaiyoKakuteiYmd ? filter.dateFormatter(elem.sagyoNaiyoKakuteiYmd) : ''
        elem2.unchinCheckYmdDisp = elem.unchinCheckYmd ? filter.dateFormatter(elem.unchinCheckYmd) : ''
        elem2.hatsuchiYmdDisp = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem2.chakuchiYmdDisp = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem2.seikyuYoteiYmdDisp = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        elem2.mitsumoriSagyoKingakuKeiDisp = elem.mitsumoriSagyoKingakuKei === null || elem.mitsumoriSagyoKingakuKei === undefined ? '' : filter.numericFormatter(elem.mitsumoriSagyoKingakuKei)
        elem2.mitsumoriBuzaiKingakuKeiDisp = elem.mitsumoriBuzaiKingakuKei === null || elem.mitsumoriBuzaiKingakuKei === undefined ? '' : filter.numericFormatter(elem.mitsumoriBuzaiKingakuKei)
        elem2.mitsumoriChoseiKingakuDisp = elem.mitsumoriChoseiKingaku === null || elem.mitsumoriChoseiKingaku === undefined ? '' : filter.numericFormatter(elem.mitsumoriChoseiKingaku)
        elem2.mitsumoriChoseiKomiKingakuKeiDisp = elem.mitsumoriChoseiKomiKingakuKei === null || elem.mitsumoriChoseiKomiKingakuKei === undefined ? '' : filter.numericFormatter(elem.mitsumoriChoseiKomiKingakuKei)
        elem2.seikyuSagyoKingakuKeiDisp = elem.seikyuSagyoKingakuKei === null || elem.seikyuSagyoKingakuKei === undefined ? '' : filter.numericFormatter(elem.seikyuSagyoKingakuKei)
        elem2.seikyuBuzaiKingakuKeiDisp = elem.seikyuBuzaiKingakuKei === null || elem.seikyuBuzaiKingakuKei === undefined ? '' : filter.numericFormatter(elem.seikyuBuzaiKingakuKei)
        elem2.seikyuChoseiKingakuDisp = elem.seikyuChoseiKingaku === null || elem.seikyuChoseiKingaku === undefined ? '' : filter.numericFormatter(elem.seikyuChoseiKingaku)
        elem2.seikyuChoseiKomiKingakuKeiDisp = elem.seikyuChoseiKomiKingakuKei === null || elem.seikyuChoseiKomiKingakuKei === undefined ? '' : filter.numericFormatter(elem.seikyuChoseiKomiKingakuKei)
        elem2.shiharaiKingakuKeiDisp = elem.shiharaiKingakuKei === null || elem.shiharaiKingakuKei === undefined ? '' : filter.numericFormatter(elem.shiharaiKingakuKei)
        elem2.shiharaiChoseiKingakuKeiDisp = elem.shiharaiChoseiKingakuKei === null || elem.shiharaiChoseiKingakuKei === undefined ? '' : filter.numericFormatter(elem.shiharaiChoseiKingakuKei)
        elem2.shiharaiChoseiKomiKingakuKeiDisp = elem.shiharaiChoseiKomiKingakuKei === null || elem.shiharaiChoseiKomiKingakuKei === undefined ? '' : filter.numericFormatter(elem.shiharaiChoseiKomiKingakuKei)
        elem2.isSelectable = !elem.seikyuTomeFlg
        return elem2
      })
    },
    isKaikeiRenkeiButtonDisabled () {
      return this.rec.length === 0
    },
    isCreateButtonDisp () {
      return this.modeKengen >= 1
    },
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      jininList: 'DDMasters/mstJinin',
      shubetsuList: 'DDMasters/mstShubetsu',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    // 得意先
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'mstjinin', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('TGUTLD0010.defineHeaderPromise')
            self.headers = [
              { text: '請求止め', value: 'seikyuTomeFlgString', align: 'center' },
              { text: '連携データ作成', value: 'seikyuZumiFlgString', align: 'center' },
              { text: '連携データ作成日', value: 'seikyuYoteiYmdDisp', align: 'center' },
              { text: '作業予定日FROM', value: 'hatsuchiYmdDisp', align: 'center' },
              { text: '作業予定日TO', value: 'chakuchiYmdDisp', align: 'center' },
              { text: '客先注文番号', value: 'chumonNo' },
              { text: '得意先', value: 'tokuisakiNm' },
              { text: '取付先', value: 'toritsukesakiNm' },
              { text: '営業所', value: 'denpyoBiko1' },
              { text: '作業区分', value: 'sagyoKbnNm' },
              { text: '依頼台数', value: 'iraiDaisu' },
              { text: '受付担当者', value: 'uketsukeTantoshaNm' },
              { text: '受付日', value: 'juchuYmdDisp', align: 'center' },
              { text: '自社管理番号', value: 'jishaDenpyoNo' },
              { text: '注文ステータス', value: 'chumonStatus' },
              { text: '請求ランク', value: 'seikyuRankSbtNm' },
              { text: '作業内容確定', value: 'sagyoNaiyoKakuteiFlgString', align: 'center' },
              { text: '作業内容確定担当者', value: 'sagyoNaiyoKakuteiTantoshaNm' },
              { text: '作業内容確定日', value: 'sagyoNaiyoKakuteiYmdDisp', align: 'center' },
              { text: '請求確定', value: 'unchinKakuteiFlgString', align: 'center' },
              { text: '請求確定担当者', value: 'unchinCheckTantoshaNm' },
              { text: '請求確定日', value: 'unchinCheckYmdDisp', align: 'center' },
              { text: 'ジャンル', value: 'genreSbtNm' },
              { text: '担当者', value: 'denpyoBiko2' },
              { text: '電話番号', value: 'denpyoBiko3' },
              { text: '取付先 郵便番号', value: 'toritsukesakiYubinNo' },
              { text: '取付先 住所1', value: 'toritsukesakiJusho1' },
              { text: '取付先 住所2', value: 'toritsukesakiJusho2' },
              { text: '電話番号2', value: 'toritsukesakiJusho3' },
              { text: '作業場所 郵便番号', value: 'sagyobashoYubinNo' },
              { text: '作業場所 住所1', value: 'sagyobashoJusho1' },
              { text: '作業場所 住所2', value: 'sagyobashoJusho2' },
              { text: '作業場所 住所3', value: 'sagyobashoJusho3' },
              { text: '取付先備考', value: 'toritsukesakiBiko' },
              { text: '商品', value: 'shohinNm' },
              { text: '受付備考', value: 'uketsukeBiko' },
              { text: '見積差分備考', value: 'mitsumoriSabunBiko' },
              { text: '宛名', value: 'denpyoBiko4' },
              { text: '件名', value: 'kenmeiSbtNm' },
              { text: '納入場所', value: 'denpyoBiko5' },
              { text: '有効期限', value: 'yukokigenSbtNm' },
              { text: '見積備考', value: 'mitsumoriBiko' },
              { text: '会社コード', value: 'denpyoBiko6' },
              { text: 'IPアドレス', value: 'denpyoBiko7' },
              { text: 'ポート番号', value: 'denpyoBiko8' },
              { text: '見積作業金額計', value: 'mitsumoriSagyoKingakuKeiDisp', align: 'end' },
              { text: '見積部材金額計', value: 'mitsumoriBuzaiKingakuKeiDisp', align: 'end' },
              { text: '見積金額計', value: 'mitsumoriChoseiKomiKingakuKeiDisp', align: 'end' },
              { text: '請求作業金額計', value: 'seikyuSagyoKingakuKeiDisp', align: 'end' },
              { text: '請求部材金額計', value: 'seikyuBuzaiKingakuKeiDisp', align: 'end' },
              { text: '請求金額計', value: 'seikyuChoseiKomiKingakuKeiDisp', align: 'end' },
              { text: '支払金額計', value: 'shiharaiKingakuKeiDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              juchuStartYmdString: null,
              juchuEndYmdString: null,
              tokuisakiId: null,
              miseikyuFlg: true,
              includeSeikyuTomeFlg: false,
              unchinKakuteiFlg: true
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('TGUTLD0010.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          if (Object.keys(c).length !== 0) {
          }
          console.log('TGUTLD0010.savedInputRestorePromise', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('TGUTLD0010.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('TGUTLD0010.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      console.log('★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★')
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCTgrcod0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rec = []
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            // const d = new Date()
            this.conditions = {
              juchuStartYmdString: null,
              juchuEndYmdString: null,
              tokuisakiId: null,
              miseikyuFlg: true,
              includeSeikyuTomeFlg: false,
              unchinKakuteiFlg: true
            }
            this.searchText = ''
            this.rows = []
            this.rec = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log(this.rows)
      this.Effects.loadStart()
      this.clear()
    },
    // onRowClick: function (e) {
    //   console.log(e)
    //   this.Effects.loadStart()

    //   this.transition(0, { id: e.trJuchuMeisaiId })
    // },
    // selectAllExcludeSeikyuTome: function (e) {
    //   if (e.value === true) {
    //     if (e.items) {
    //       const target = e.items.filter((elem) => !elem.seikyuTomeFlg)
    //       if (this.rec.filter((elem) => !elem.seikyuTomeFlg).length === target.length) {
    //         this.rec = []
    //       } else {
    //         const newRec = target.filter((elem) => this.rec.every((item) => item.trJuchuMeisaiId !== elem.trJuchuMeisaiId))
    //         this.rec = [...this.rec, ...newRec]
    //       }
    //     }
    //   } else {
    //     this.rec = []
    //   }
    // },
    onKaikeiRenkeiButtonClick: function (issueFlg) {
      this.Effects.loadStart()
      const idList = this.rec.map(elem => elem.trJuchuMeisaiId)
      this.HttpClient
        .post(`/api/v1/vwCTgutld0010/Download?issueFlg=${issueFlg}`, { trJuchuMeisaiIdList: idList })
        .then((data) => {
          this.Effects.loadComplete()
          if (typeof data !== 'string' && !data.isValid) {
            this._setMessages(data).then(() => {})
          } else {
            this.clearSummaryMessage()
            const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
            const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
            const blob = new Blob([bom, data], { type: 'text/csv' })
            const elem = document.getElementById('download')
            elem.href = window.URL.createObjectURL(blob)
            elem.download = '会計連携データ' + (issueFlg ? '_' : '(仮)_') + ts + '.csv'
            elem.click()

            this.rec = []
            this.onSearchButtonClick()
          }
        })
    },
    searchValidate: function () {
      console.log('searchValidate')
      // 受付日FROM TOの大小チェック
      var msg = validators.compareDate(this.conditions.juchuStartYmdString, this.conditions.juchuEndYmdString)
      if (msg !== undefined) {
        this.$refs.juchuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.juchuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }

      return true
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    }
  }
}
